/*
 * Order now.
 *
 * Stands in for Shopify's dynamic checkout button (Buy with Shop, Pay with
 * PayPal, More payment options) on the product page. It adds the chosen
 * variant to the cart and goes straight to checkout, where all of those
 * payment methods are offered.
 *
 * The cart is added to, not replaced, so checkout always shows exactly what
 * is in the cart.
 *
 * The button follows Add to cart's disabled state, which Dawn updates every
 * time the selected variant changes (sold out, unavailable).
 */
if (!customElements.get('jo-order-now')) {
  customElements.define(
    'jo-order-now',
    class JoOrderNow extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.button = this.querySelector('button');
        this.form = document.getElementById(this.dataset.formId);
        this.addButton = document.getElementById(this.dataset.addButtonId);
        if (!this.button || !this.form) return;

        this.button.addEventListener('click', this.onClick.bind(this));

        if (this.addButton) {
          this.syncDisabled();
          this.observer = new MutationObserver(this.syncDisabled.bind(this));
          this.observer.observe(this.addButton, { attributes: true, attributeFilter: ['disabled'] });
        }

        // Coming back from checkout with the Back button restores this page
        // from cache, still showing the spinner.
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.reset();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.bound = false;
      }

      syncDisabled() {
        this.button.disabled = this.addButton.hasAttribute('disabled');
      }

      onClick() {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const productForm = this.form.closest('product-form');
        productForm?.handleErrorMessage();

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(this.form);

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              productForm?.handleErrorMessage(response.description || response.message);
              this.reset();
              return;
            }
            window.location.href = this.dataset.checkoutUrl;
          })
          .catch(() => {
            productForm?.handleErrorMessage(window.cartStrings.error);
            this.reset();
          });
      }

      reset() {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        this.button.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  );
}
